import { useTranslate } from "@refinedev/core";
import { CalendarIcon, SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Pension — boarding rules + capacity. Vestiging context only (module-gated on `pension` in Jmix).
// Migrated: the card opens the in-SPA Pension detail (PensionSettings) hosting Berekening pension /
// Hoogseizoen dagen / Capaciteit, scoped to the active branch.
export const PENSION_TILE_KEY = "pension";

const ITEM_KEYS = [
  "instellingen.item.berekeningPension",
  "instellingen.item.hoogseizoenDagen",
  "instellingen.item.capaciteit",
];

export function PensionTile({ context, onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  if (context.type !== "branch") return null;
  return (
    <SettingsTileCard
      tileKey={PENSION_TILE_KEY}
      icon={<CalendarIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.pension.title")}
      description={t("instellingen.tile.pension.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("pension")}
    />
  );
}
